module.exports = __webpack_public_path__ + "img/img_mainland_account_open_4.fb94157a.png";